import * as React from "react";
const SvgArrowBack = (props) => /* @__PURE__ */ React.createElement("svg", { width: 16, height: 14, viewBox: "0 0 16 14", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M16 7H2M2 7L7.81818 1.5M2 7L7.81818 12.5", stroke: "#00010F", strokeWidth: 1.8 }));
export default SvgArrowBack;
